import { ApiClient } from "../base";
export class OpenShellClient extends ApiClient {
    createSandbox(payload) {
        return this.base.post(`agents/launch`, payload);
    }
    updateSandbox(payload) {
        return this.base.post(`agents/update`, payload);
    }
    getSandbox(name) {
        return this.base.get(`sandboxes/${encodeURIComponent(name)}`);
    }
    getSandboxes(folderId) {
        const params = new URLSearchParams();
        if (folderId) {
            params.append("folder_id", folderId.toString());
        }
        return this.base.get(`sandboxes?${params}`);
    }
    getProviders(keys) {
        const params = new URLSearchParams();
        if (keys) {
            for (const key of keys) {
                params.append("key", key);
            }
        }
        return this.base.get(`providers?${params}`);
    }
    getProvider(name) {
        return this.base.get(`providers/${name}`);
    }
    createProvider(provider) {
        return this.base.post(`providers`, provider);
    }
    updateProvider(name, update) {
        return this.base.patch(`providers/${name}`, update);
    }
    deleteProvider(name) {
        return this.base.delete(`providers/${name}`);
    }
    getSkillsCatalog() {
        return this.base.get(`skills/catalog`);
    }
    getProviderProfiles() {
        return this.base.get(`provider-profiles`);
    }
    getProviderProfile(id) {
        return this.base.get(`provider-profiles/${id}`);
    }
    createProviderProfile(profile) {
        return this.base.post(`provider-profiles`, profile);
    }
    deleteProviderProfile(id) {
        return this.base.delete(`provider-profiles/${id}`);
    }
    lintProviderProfile(request) {
        return this.base.post(`provider-profiles/lint`, request);
    }
    configureProviderRefresh(providerName, request) {
        return this.base.post(`providers/${encodeURIComponent(providerName)}/refresh`, request);
    }
    getProviderRefreshStatus(providerName) {
        return this.base.get(`providers/${encodeURIComponent(providerName)}/refresh`);
    }
    rotateProviderRefreshCredential(providerName, credentialKey) {
        return this.base.post(`providers/${encodeURIComponent(providerName)}/refresh/${encodeURIComponent(credentialKey)}`);
    }
    deleteProviderRefreshCredential(providerName, credentialKey) {
        return this.base.delete(`providers/${encodeURIComponent(providerName)}/refresh/${encodeURIComponent(credentialKey)}`);
    }
}
